import model from "../../../../content/blogs/BACUDA/model.png";
import * as React from 'react';
export default {
  model,
  React
};